import React, { memo, useCallback } from 'react';
import { Keyboard, TouchableOpacity, View } from 'react-native';
import Text from 'design-system/Text';
import Modal from 'utils/packages/Modal';
import { hitSlopS, IconArrow, rem, Spacer } from 'design-system';
import IconTooltip from 'design-system/icons/IconTooltip';
import LogoBankAccount from 'design-system/LogoBankAccount';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { formatSortCodeAndAccountNumber } from 'utils/formatting';
import Amount from 'design-system/Amount';
import { fundingAccountToolTipStrings } from '../constants';
import { selectConnectedAccountBalanceFromConnectedAccountWithBankId } from '../hooks/selectors';
const ConnectedAccountRow = ({ account, onPress, description, isPickerModalOpen, }) => {
    const styles = useStyles(styleSet);
    const connectedAccountBalance = useAppSelector(selectConnectedAccountBalanceFromConnectedAccountWithBankId);
    const onInfoButtonPress = useCallback(() => {
        Keyboard.dismiss();
        Modal.showConfirmation({
            title: fundingAccountToolTipStrings.fundingAccountTitle,
            subtitle: fundingAccountToolTipStrings.fundingAccountDesc,
            confirmButtonTitle: 'Okay',
        });
    }, []);
    const disabled = !onPress;
    const hideAvailable = description === 'Direct Debit';
    return (<TouchableBounceCard onDark disabled={disabled} noMarginTop noMarginBottom style={styles.cardBtn} onPress={onPress}>
      <View style={styles.row}>
        <View style={styles.iconContainer}>
          <LogoBankAccount size="R44" data={account}/>
        </View>
        <Spacer w={16}/>
        <View style={styles.flex}>
          <Text Text-16 numberOfLines={1}>
            {account.bankName || 'Linked bank'}
          </Text>
          {!hideAvailable && (<View style={styles.row}>
              {connectedAccountBalance ? (<>
                  <Text TextThin-14 Secondary>
                    Available{' '}
                  </Text>
                  <Amount NumbersThin-14 Secondary value={connectedAccountBalance}/>
                </>) : (<Text TextThin-14 Secondary>
                  {formatSortCodeAndAccountNumber(account.ukSortCode, account.ukAccountNumber)}
                </Text>)}
              <Spacer w={4}/>
              <TouchableOpacity onPress={onInfoButtonPress} hitSlop={hitSlopS}>
                <IconTooltip colorKey="secondary" width={16} height={16}/>
              </TouchableOpacity>
            </View>)}
          {!!description && (<Text TextThin-14 Secondary>
              {description}
            </Text>)}
        </View>
        {!disabled && (<View style={styles.arrow}>
            <IconArrow direction={isPickerModalOpen ? 'up' : 'down'}/>
          </View>)}
      </View>
    </TouchableBounceCard>);
};
const styleSet = createStyleSheets((colors) => ({
    cardBtn: {
        paddingVertical: rem(24),
        paddingHorizontal: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    iconContainer: {
        width: rem(42),
        height: rem(42),
        borderWidth: rem(1),
        alignItems: 'center',
        borderRadius: rem(21),
        justifyContent: 'center',
        borderColor: colors.borders.logoStroke,
        backgroundColor: colors.background.contrast,
    },
    flex: {
        flex: 1,
    },
    arrow: {
        width: rem(10),
        marginLeft: rem(16),
    },
}));
export default memo(ConnectedAccountRow);
